// extracted by mini-css-extract-plugin
export default {"root":"AJoXjR","icon":"bp7kv0","badge":"XJWqCW"};